(function (app, ng) {

    app.controller("fileDetailsController", fileDetailsController);

    fileDetailsController.$inject = ["$mdDialog", "figToaster", "marketingTrackerUserFileApi"];
    function fileDetailsController($mdDialog, figToaster, marketingTrackerUserFileApi) {
        var $ctrl = this;

        $ctrl.updateFileName = function ($event, file) {
            $ctrl.savingData = true;
            if ($ctrl.form.$valid) {
                file.ModifiedByUserId = $ctrl.user.Id;
                file.ModifiedByUser = $ctrl.user;
                file.ModifiedOn = new Date().toISOString();
                    marketingTrackerUserFileApi.updateFileName(file.Id, file)
                    .then(function () {
                        toastClass = "is-success";
                        toastMessage = "Changes saved.";
                        $mdDialog.hide($event);
                    })
                    .catch(function (reason) {
                        toastClass = "is-error";
                        if (reason) {
                            toastMessage = reason.data;
                        } else {
                            toastMessage = "There was a problem adding your files. Please try again shortly.";
                        }
                    })
                    .finally(function () {
                        $ctrl.savingData = false;
                        figToaster.showSimple(toastMessage, "top", toastClass);
                    });
            }
        };

        $ctrl.downloadFile = function (file) {
            marketingTrackerUserFileApi.downloadFile(file.Id)
                .then(function (response) {
                    var f = document.createElement("a");
                    document.body.appendChild(f);
                    f.style = "display: none";

                    var fUrl = window.URL.createObjectURL(response);
                    f.href = fUrl;
                    f.download = file.FileName;
                    f.click();

                    setTimeout(function () {
                        document.body.removeChild(file);
                        window.URL.revokeObjectURL(fUrl);
                    },
                        100);
                })
                .then(function () {
                    $mdDialog.hide($event);
                });
        };

        $ctrl.close = function ($event) {
            $mdDialog.cancel($event);
        };

        $ctrl.$onInit = function () {
            $ctrl.localFile = $ctrl.file;
            if ($ctrl.localFile.ContentType.includes('image')) {
                $ctrl.loadingPreviewUrl = true;
                $ctrl.localFile.PreviewUrl = true;
                marketingTrackerUserFileApi.downloadFile($ctrl.localFile.Id).then(function (response) {
                    $ctrl.localFile.PreviewUrl = window.URL.createObjectURL(response);
                    $ctrl.loadingPreviewUrl = false;
                });
            }
        };
    }

})(window.app, window.angular); //jshint ignore:line